import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { FacilityAllocation } from './facility-allocation.model';
import { Action } from 'rxjs/internal/scheduler/Action';
import { SelectItem } from '../../../shared/efaact-primeng.module';

export const loadFacilityAllocations = createAction(
    '[FacilityAllocation/API] Load FacilityAllocations',
    props<{ facilityAllocations: FacilityAllocation[] }>()
);

export const addFacilityAllocation = createAction(
    '[FacilityAllocation/API] Add FacilityAllocation',
    props<{ facilityAllocation: FacilityAllocation }>()
);

export const upsertFacilityAllocation = createAction(
    '[FacilityAllocation/API] Upsert FacilityAllocation',
    props<{ facilityAllocation: FacilityAllocation }>()
);

export const addFacilityAllocations = createAction(
    '[FacilityAllocation/API] Add FacilityAllocations',
    props<{ facilityAllocations: FacilityAllocation[] }>()
);

export const upsertFacilityAllocations = createAction(
    '[FacilityAllocation/API] Upsert FacilityAllocations',
    props<{ facilityAllocations: FacilityAllocation[] }>()
);

export const updateFacilityAllocation = createAction(
    '[FacilityAllocation/API] Update FacilityAllocation',
    props<{ facilityAllocation: Update<FacilityAllocation> }>()
);

export const updateFacilityAllocations = createAction(
    '[FacilityAllocation/API] Update FacilityAllocations',
    props<{ facilityAllocations: Update<FacilityAllocation>[] }>()
);

export const deleteFacilityAllocation = createAction(
    '[FacilityAllocation/API] Delete FacilityAllocation',
    props<{ id: string }>()
);

export const deleteFacilityAllocations = createAction(
    '[FacilityAllocation/API] Delete FacilityAllocations',
    props<{ ids: string[] }>()
);

export const clearFacilityAllocations = createAction(
    '[FacilityAllocation/API] Clear FacilityAllocations'
);
export const getFacilityAllocations = createAction(
    '[FacilityAllocation/API] Get FacilityAllocations'
);
export const putFacilityAllocations = createAction(
    '[FacilityAllocations/API] Put FacilityAllocations',
    props<{ facilityAllocations: FacilityAllocation[] }>()
);
export const getFacilityAllocationTypes = createAction(
    '[FacilityAllocations/API] Get FacilityAllocationTypes'
);
export const loadFacilityAllocationTypes = createAction(
    '[FacilityAllocations/API] Load FacilityAllocationTypes',
    props<{ facilityAllocationTypes: SelectItem[] }>()
);
